<ion-list lines="none">
  <ion-item>
    <ion-icon src="/assets/icons/24px/headphones.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Why Headphones Matter</h3>
      </ion-text>

      <ion-text color="black">
        <p>You can Disable Echo Cancellation when you are wearing Headphones</p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item>
    <ion-icon src="/assets/icons/24px/echo-cancellation.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Why Echo Cancellation Matters</h3>
      </ion-text>

      <ion-text color="black">
        <p>Echo Cancellation prevents feedback loops between Microphones and Speakers</p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item>
    <ion-icon src="/assets/icons/24px/duck.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Does it Impact Quality</h3>
      </ion-text>

      <ion-text color="black">
        <p>The tradeoff is Volume Ducking that lowers Quality when speaking at the same time</p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item>
    <ion-icon src="/assets/icons/24px/echo-cancellation.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Avoid Impacting Quality</h3>
      </ion-text>

      <ion-text color="black">
        <p>With Echo Cancellation Disabled quality will not be affected by Volume Ducking</p>
      </ion-text>
    </ion-label>
  </ion-item>
</ion-list>
